import React from 'react';

import PropTypes from 'prop-types';

import { TagList } from '../../Tag';
import { tagShape } from '../../../types';

const TagsCell = ({ tags }) => <TagList tags={tags} />;

TagsCell.propTypes = {
  tags: PropTypes.arrayOf(tagShape).isRequired,
};

export default TagsCell;
